import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown degli stili del testo */
@Component({
  selector: 'app-font-style',
  templateUrl: './font-style.component.html',
  styleUrls: ['./font-style.component.css']
})
export class FontStyleComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input() public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.value = value;
    console.log(value);
    this.valueChange.emit(value);
  }
  constructor() { }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext () {};
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious () {};
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection () {};
}
